/**
 * Two options template for configurator
 * Converted from legacy JS to TypeScript
 */

import { ConfiguratorConfig } from '../types';
import translationInstance from '../utils/translations';

export const createTwoOptionsTemplate = (modelId: string): ConfiguratorConfig => {
  // Get translation function
  const t = translationInstance.t.bind(translationInstance);

  return {
    viewer: {
      modelId: modelId,
      background: {
        color: [0.91015625, 0.91015625, 0.91015625],
      },
      defaultActions: [],
    },
    configurator: {
      options: [
        {
          _id: '5e6c9e6d-09ec-4c02-9538-section-1',
          actions: [],
          controlType: 'section',
          name: t('virtenzo.configurator.section_wood'),
          headlineText: t('virtenzo.configurator.section_wood'),
          classes: ['virtenzo-panel-section'],
          subOptions: [
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a6',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.section_wood'),
              classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
              href: '',
            },
            {
              _id: '8004c9f8-1534-4601-808b-bae614e372f2',
              actions: [
                {
                  _id: '9a87ee91-aa42-4d8b-a61b-b3db44d4ed46',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'wood_American Walnut Natural Oil_0',
                  materialName: 'Natural Beech',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD',
                  value: 'BEECH',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/natural_beech_diffuse.jpg',
              name: 'Natural Beech',
              text: 'Natural Beech',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Wood',
            },
            {
              _id: '74b1c17f-2bb4-4707-ab72-a651fe8586a4',
              actions: [
                {
                  _id: 'ce6d84ac-a937-4d37-83a5-88f7d92a36ba',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'wood_American Walnut Natural Oil_0',
                  materialName: 'Walnut Nature',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'WOOD',
                  value: 'WALNUT',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/walnut_nature_diffuse.jpg',
              name: 'Walnut Nature',
              text: 'Walnut Nature',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Wood',
            }
          ]
        },
        {
          _id: '5e6c9e6d-09ec-4c02-9538-section-2',
          actions: [],
          controlType: 'section',
          name: t('virtenzo.configurator.finish'),
          headlineText: t('virtenzo.configurator.finish'),
          classes: ['virtenzo-panel-section'],
          subOptions: [
            {
              _id: '31f7a2ff-d4d5-47d3-8c67-64c0416cf9a8',
              actions: [],
              controlType: 'sectionHeadline',
              name: t('virtenzo.configurator.finish'),
              classes: ['virtenzo-panel-section-headline', 'section-root-headline', 'big-headline'],
              href: '',
            },
            {
              _id: '8004c9f8-1534-4601-808b-bae614e372f3',
              actions: [
                {
                  _id: '9a87ee91-aa42-4d8b-a61b-b3db44d4ed47',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'finish_material',
                  materialName: 'Matte Finish',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'FINISH',
                  value: 'MATTE',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/matte_finish.jpg',
              name: 'Matte Finish',
              text: 'Matte Finish',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Finish',
            },
            {
              _id: '74b1c17f-2bb4-4707-ab72-a651fe8586a5',
              actions: [
                {
                  _id: 'ce6d84ac-a937-4d37-83a5-88f7d92a36bb',
                  functionName: 'setMaterialByObjectNameMaterialName',
                  name: 'finish_material',
                  materialName: 'Glossy Finish',
                },
                {
                  functionName: 'setSystemVariable',
                  name: 'FINISH',
                  value: 'GLOSSY',
                },
              ],
              controlType: 'imageButton',
              imageSrc: 'https://static.virtenzo.com/clients/estetica-home/textures/glossy_finish.jpg',
              name: 'Glossy Finish',
              text: 'Glossy Finish',
              classes: ['virtenzo-panel-button'],
              href: '',
              groups: 'Finish',
            }
          ]
        }
      ]
    }
  };
};
